import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { gridSizeMdLg12, newCooperativaSchema, ROUTER_PATHS } from '@/shared';
import { useFetchEntidadesFinancieras } from '@/shared/actions/erp';
import {
  CustomAutocomplete,
  CustomTextField,
  ModelStateSelect,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { Cooperativa, EntidadesFinancieras } from '@/shared/interfaces';
import { useCreateCooperativa, useUpdateCooperativa } from '@/shared/actions/erp/cooperativa.actions';


const returnUrlEntidades = ROUTER_PATHS.administration.cooperativa_nav;

export interface SaveCooperativaInterface {
  titlePage: string;
  editCooperativa?: Cooperativa;
}

type SaveFormData = {
  nombre: string;
  //codigo: string;
  numero_referencia: string;
  codigo_auxiliar: string
  entidad_financiera: string;
  estado?: boolean;
};

const SaveCooperativa: React.FC<SaveCooperativaInterface> = ({ titlePage, editCooperativa }) => {

  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createCooperativa = useCreateCooperativa({ navigate, returnUrl: returnUrlEntidades });
  const updateCooperativaMutation = useUpdateCooperativa({ navigate, returnUrl: returnUrlEntidades });
  const { data: dataEntidadFinanciera, isLoading: isLoadingEntidadFinanciera } = useFetchEntidadesFinancieras({
    page_size: 100
  });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newCooperativaSchema),
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid },
    control
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editCooperativa?.id_cooperativa) {
      return updateCooperativaMutation.mutate({
        id: editCooperativa.id_cooperativa,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createCooperativa.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editCooperativa) {
      setShrink(true);
      reset({
        ...editCooperativa,
        estado: !!editCooperativa.estado ? '1' : '0',
      } as any);
    }
  }, [editCooperativa]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlEntidades);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        control={control}
        name="nombre"
        defaultValue={form.getValues().nombre}
        size={gridSizeMdLg12}
        label={'Nombre'}
        error={errors.nombre}
        helperText={errors.nombre?.message} />

      <CustomTextField
        control={control}
        name="codigo_auxiliar"
        type='none'
        defaultValue={form.getValues().codigo_auxiliar}
        size={gridSizeMdLg12}
        label={'Codigo Cooperativa'}
        error={errors.codigo_auxiliar}
        helperText={errors.codigo_auxiliar?.message} />


      <CustomTextField
        label="Numero Referencia"
        control={control}
        name="numero_referencia"
        error={errors.numero_referencia}
        helperText={errors.numero_referencia?.message}
        shrink={shrink}
      />

      <CustomAutocomplete<EntidadesFinancieras>
        label="Entidad financiera"
        name="entidad_financiera"
        // options
        options={dataEntidadFinanciera?.data.data || []}
        valueKey="nombre"
        actualValueKey="codigo"
        defaultValue={form.getValues().entidad_financiera || ''}
        isLoadingData={isLoadingEntidadFinanciera}
        // validation
        control={form.control}
        error={form.formState.errors.entidad_financiera}
        helperText={
          form.formState.errors.entidad_financiera?.message
        }
      />

      {/* ====== state ====== */}
      <ModelStateSelect
        defaultValue={form.getValues().estado || ''}
        register={register('estado')}
        error={errors.estado}
        helperText={errors.estado?.message}
      />
    </SingleFormBoxScene>
  );
};

export default SaveCooperativa;
